import { render, staticRenderFns } from "./index.vue?vue&type=template&id=480fb1f4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=480fb1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480fb1f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480fb1f4')) {
      api.createRecord('480fb1f4', component.options)
    } else {
      api.reload('480fb1f4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=480fb1f4&scoped=true&", function () {
      api.rerender('480fb1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/dashboard/index.vue"
export default component.exports